import { jsx as r } from "react/jsx-runtime";
import { AudioFileIcon as s } from "./AudioFile.icon.js";
import { CodeFileIcon as c } from "./CodeFile.icon.js";
import { DocFileIcon as a } from "./DocFile.icon.js";
import { FileIcon as m } from "./File.icon.js";
import { PdfFileIcon as t } from "./PdfFile.icon.js";
import { PptFileIcon as i } from "./PptFile.icon.js";
import { TxtFileIcon as l } from "./TxtFile.icon.js";
import { VideoFileIcon as n } from "./VideoFile.icon.js";
import { XslFileIcon as p } from "./XslFile.icon.js";
import { ZipFileIcon as f } from "./ZipFile.icon.js";
const j = (o) => {
  const e = "app:w-10 app:h-10";
  switch (o) {
    case "pdf":
      return /* @__PURE__ */ r(t, { className: e });
    case "xsl":
      return /* @__PURE__ */ r(p, { className: e });
    case "doc":
      return /* @__PURE__ */ r(a, { className: e });
    case "ppt":
      return /* @__PURE__ */ r(i, { className: e });
    case "zip":
      return /* @__PURE__ */ r(f, { className: e });
    case "audio":
      return /* @__PURE__ */ r(s, { className: e });
    case "video":
      return /* @__PURE__ */ r(n, { className: e });
    case "code":
      return /* @__PURE__ */ r(c, { className: e });
    case "txt":
      return /* @__PURE__ */ r(l, { className: e });
    default:
      return /* @__PURE__ */ r(m, { className: e });
  }
};
export {
  j as renderIcon
};
